import type { EventSession } from '../ActivityDetails.types'

const checkHasOneSession = (eventSessions: Array<EventSession>) => eventSessions.length === 1

export default checkHasOneSession
